<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AutocompleteSingle" });
import { Input } from "../../inputs/index.js";
import { DataListSingle } from "../index.js";
import Icon from "../../elements/icon/Icon.svelte";
import { onMount } from "svelte";
export let key;
export let options = [];
export let name;
export let isDisabled = false;
export let isRequired = false;
export let label = void 0;
export let hint = void 0;
export let placeholder = void 0;
export let blacklist = [];
export let whitelist = [];
export let query = void 0;
export let showListAlwaysForSingleOption = false;
const DEFAULT_PLACEHOLDER = placeholder;
let showList = false;
let dataListSingleComponent;
const clearQueryAndKey = () => {
    key = void 0;
    query = void 0;
    placeholder = DEFAULT_PLACEHOLDER;
};
const onKeyChange = (key2) => {
    if (key2 === void 0) {
        placeholder = DEFAULT_PLACEHOLDER;
        query = void 0;
        return;
    }
    const OPTION = options.find((option) => option.key === key2);
    if (OPTION === void 0) {
        return;
    }
    showList = false;
    placeholder = OPTION.label;
    query = void 0;
};
$: onKeyChange(key);
$: singleCheckedOption = key === options[0]?.key && options.length === 1 && !showListAlwaysForSingleOption;
$: whitelistedOptions = whitelist.length > 0 ? options.filter((option) => whitelist.includes(option.key)) : options;
const onOptionsChange = (options2) => {
    if (key === void 0) {
        return;
    }
    const OPTION = options2.find((option) => option.key === key);
    if (OPTION === void 0) {
        return;
    }
    placeholder = OPTION.label;
};
$: onOptionsChange(options);
const toggleList = () => {
    if (singleCheckedOption) {
        return;
    }
    if (!showList) {
        query = void 0;
    }
    showList = !showList;
};
const onKeyPress = (event) => {
    if (event.code === "Enter") {
        dataListSingleComponent.onEnterClicked();
    }
    if (event.code === "Tab") {
        query = void 0;
        showList = false;
    }
};
onMount(() => {
    if (key === "") {
        key = void 0;
    }
});
let validation = "";
const setValidation = (key2, isRequired2) => {
    if (isRequired2 && key2 === void 0) {
        return "value_missing";
    }
    return "";
};
$: validation = setValidation(key, isRequired);
</script>

<div
    class = 's8-autocomplete-single'
    class:s8-selected = { Boolean(key) }
    class:s8-has-label = { label !== undefined }
>
    {#if Array.isArray(options)}

        <Input
            bind:value = { query }
            on:click = { toggleList }
            on:keydown = { onKeyPress }
            isDisabled = { isDisabled || singleCheckedOption }
            isRequired = { false }
            { validation }
            { hint }
            { label }
            { placeholder }
            { name }
            hasMinItems = { isRequired }
        >
            <svelte:fragment slot = 'afterInput'>

                {#if !isDisabled && !singleCheckedOption}

                    {#if key !== undefined}
                        <Icon
                            key = 'close'
                            css = 's8-select-icon'
                            on:click = { clearQueryAndKey }
                        />
                    {:else}
                        <Icon
                            key = { showList ? 'chevronUp' : 'chevronDown' }
                            css = 's8-select-icon'
                            on:click = { toggleList }
                        />
                    {/if}

                {/if}

            </svelte:fragment>
        </Input>

        <DataListSingle
            bind:key
            bind:this = { dataListSingleComponent }
            bind:showList = { showList }
            bind:query = { query }
            on:noMatches
            on:hasMatches
            options = { whitelistedOptions }
            { blacklist }
            { name }
        />

    {/if}
</div>

<style>

    div.s8-autocomplete-single {
        position: relative;
        width: 100%;
        color: #272711;
    }

        div.s8-autocomplete-single.s8-selected :global(input:not(:focus):not(:invalid):not(:disabled)::-moz-placeholder) {
                color: inherit !important;
            }

        div.s8-autocomplete-single.s8-selected :global(input:not(:focus):not(:invalid):not(:disabled)::placeholder) {
                color: inherit !important;
            }

        div.s8-autocomplete-single :global(svg.s8-select-icon) {
            cursor: pointer !important;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            height: 14px;
            right: 10px;
        }

        div.s8-autocomplete-single.s8-has-label :global(div.s8-datalist-single) {
                top: 60px;
            }</style>